import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { vueCookie } from 'utils/vueCookie';
import {
    useNumberStore,
    useOrganizationStore,
    useSubscriptionsStore,
    useUserStore,
} from 'store/modules';
import { getParserToken } from 'core/api/setTokenLocalStorage';

const id = uuidv4();

const payload = () => {
    const userStore = useUserStore();
    const organizationStore = useOrganizationStore();
    const subscriptionsStore = useSubscriptionsStore();
    const numberStore = useNumberStore();

    const user = userStore.user;
    const organization = organizationStore.organization;
    const subscription = subscriptionsStore.subscription;
    const number = numberStore.number;
    const config = userStore.config;
    const z_index = 30;
    const anonymous_id = (() => {
        const exist_id = localStorage.getItem('intercom-anonymous_id');

        if (!exist_id) {
            localStorage.setItem('intercom-anonymous_id', id);
        }

        return localStorage.getItem('intercom-anonymous_id');
    })();

    if (!user || !organization || !subscription || !number || !config)
        return {
            z_index: z_index,
            anonymous_id: anonymous_id,
        };

    const company = {
        id: organization.id,
        name: organization.name,
        createdAt: organization.created_at,
        ownerFirstName: user.first_name,
        ownerLastName: user.last_name,
        ownerName: user.full_name,
        phone: number?.formatted_number,
        plan: subscription.plan?.id,
        planStatus: subscription.status,
    };

    return {
        email: user.email,
        id: String(user.id),
        user_id: String(user.id),
        created_at: moment.utc(user.createdAt).valueOf(),
        name: user.name,
        phone: number?.formatted_number,
        avatar: user.photo_url,
        user_hash: config.intercom,
        z_index: z_index,
        company,
    };
};

export const initIntercom = () => {
    if (!window.dataLayer) return;

    const data = getParserToken();

    if (!data || !data?.hipaa) {
        window.dataLayer.push({ event: 'intercom_init', intercom_payload: payload() });
    }
};

export const updateIntercom = () => {
    if (!window.Intercom) return;

    const data = getParserToken();

    if (!data || !data?.hipaa) {
        window.Intercom('update', payload());
    }
};

export const clearSessionIntercom = () => {
    if (!window.Intercom) {
        for (let key in vueCookie.getAllCookies()) {
            if (/^intercom-session-.+/.test(key)) {
                vueCookie.remove(key, { domain: '.salesmessage.com' });
            }
        }

        return;
    }

    window.Intercom('shutdown');
};

export const openIntercom = () => {
    if (!window.Intercom) return;

    const data = getParserToken();

    if (!data || !data?.hipaa) {
        window.Intercom('show');
    }
};
